import { render, staticRenderFns } from "./EventLiveEventerMessageForm.vue?vue&type=template&id=6318397a&scoped=true&"
import script from "./EventLiveEventerMessageForm.vue?vue&type=script&lang=js&"
export * from "./EventLiveEventerMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./EventLiveEventerMessageForm.vue?vue&type=style&index=0&id=6318397a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6318397a",
  null
  
)

export default component.exports